import React from 'react'

import ALLROADSydneyTrainsPie from './ALLROADSydneyTrainsPie'
import Iframe from 'react-iframe'

import {
  useNavigate
} from "react-router-dom";

import styled from 'styled-components'

const SummaryBox = styled.div`
  display: flex;

  font-size: 1.2rem;
  flex-grow: 1;

  gap: 3vw;

  align-items: center;
  padding-left: 2vw;
`

const SummaryEntry = styled.div`
  font-size: 1.4vw;
`

const SummaryBoxWrapper = styled.div`
  background: #FFFFFF;  /* White for contrast */
  border-radius: 15px;
  overflow: auto;
  border: 1px solid #DDDDDD;

  display: flex;
  flex-direction: column;
`

export default function ALLROADSydneyTrainsDashboard() {

  const FORM_URL = "https://calendar.google.com/calendar/embed?src=49698167708551d70af6ada0d94c077702a621c7c516c8d461e9d81f78e5068e%40group.calendar.google.com&ctz=Australia%2FSydney";

  const [jobs, setJobs] = React.useState([])
  const [pieData, setPieData] = React.useState([])
  const [monthData, setMonthData] = React.useState([])
  const [dailyData, setDailyData] = React.useState([])

  let navigate = useNavigate()

  const getDashboardData  = async () => {
    // https://ic360portalbackend.azurewebsites.net
    await fetch('https://ic360portalbackend.azurewebsites.net/api/ALLROAD/MonthlyDashboardInfo/all')
    .then(response => response.json())
    .then (data => {
      setJobs(data);
  
      formatPieJobsData(data);
      formatTodayData(data);
      formatMonthlyData(data);

      console.log(JSON.stringify(data))
    })
  }

  React.useEffect(() => {
    // Call getDashboardData initially when the component mounts
    getDashboardData();

    // Set up an interval to call getDashboardData every 30 seconds
    const intervalId = setInterval(getDashboardData, 15000);

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  // Update the pieData whenever the jobs array changes

  const formatTodayData = async (jobs) => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    const dateToday = dd + '/' + mm + '/' + yyyy;

    const todayData = jobs.reduce((acc, job) => {
      if (job.JobDate === dateToday) {
        acc.todayCrewSize += job.CrewSize;

        // Only runs this if the job is today, then we add its status
        if (job.Status === 'ONGOING') {
          acc.ongoing++;
        } else if (job.Status === 'NEW') {
          acc.new++;
        } else if (job.Status === 'SHUTDOWN') {
          acc.shutdown++;
        }
      }
      return acc;
    }, { ongoing: 0, new: 0, shutdown: 0, todayCrewSize: 0});

    setDailyData(todayData)
  }

  const formatMonthlyData = async (jobs) => {
    let today = new Date();
    let mm = Number(String(today.getMonth() + 1).padStart(2, '0'));
    let yyyy = Number(today.getFullYear());
  
    const monthJobs = jobs.reduce((acc, job) => {
      let jobDateParts = job.JobDate.split('/');
      let jobMonth = Number(jobDateParts[1]);
      let jobYear = Number(jobDateParts[2]);
      if (jobMonth === mm && jobYear === yyyy) {
        acc.monthCrewSize += job.CrewSize;
        if (job.Status === 'ONGOING') {
          acc.ongoing++;
        } else if (job.Status === 'NEW') {
          acc.new++;
        } else if (job.Status === 'SHUTDOWN') {
          acc.shutdown++;
        }
      }
      return acc;
    }, { ongoing: 0, new: 0, shutdown: 0, monthCrewSize: 0 });
  
    setMonthData(monthJobs);
  }

  const formatPieJobsData = async (jobs) =>{
    const jobCounts = jobs.reduce((acc, job) => {
      if (job.Status === 'ONGOING') {
        acc.ongoing++;
      } else if (job.Status === 'NEW') {
        acc.new++;
      } else if (job.Status === 'SHUTDOWN') {
        acc.shutdown++;
      }
      return acc;
    }, { ongoing: 0, new: 0, shutdown: 0 });

    setPieData(jobCounts);
  }

  return (
    <>
      <div className="fd-wrapper">

        <div className="fd-container">
          <div className="fd-title"><span className="fd-project-subtitle">PROJECT: </span>Sydney Trains</div>

          <div className="fd-info-container">
            <div className="fd-info-entry fd-intro-entry-top-right">
              <div className="fd-info-entry-title">
                Jobs listings
              </div>

              <div className="fd-job-listing-container">

                {/* Job Listings here */}
                {jobs.map((job, idx) => {
                  let jobListingClass = "fd-job-listing";

                  if (job.Status === "ONGOING") {
                    jobListingClass += " fd-job-listing-ongoing";
                  } else if (job.Status === "NEW") {
                    jobListingClass += " fd-job-listing-new";
                  } else if (job.Status === "SHUTDOWN") {
                    jobListingClass += " fd-job-listing-shutdown";
                  }

                  return (
                    <div className={jobListingClass} key={idx}>
                      {job.JobDate} - {job.JobEndDate} |&nbsp;
                      <span className="fd-job-listing-white">{job.JobDescription} </span>
                      {/* | <span className="fd-job-listing-white">Crewsize: {job.CrewSize}</span> */}
                    </div>
                  );
                })}
              </div>
            </div>

            <SummaryBoxWrapper>
              <div className="fd-info-entry-title">
              Monthly Summary: {new Date().toLocaleString('default', { month: 'long' })}
              </div>
                
                <SummaryBox>
                  <SummaryEntry>New: <span className='fd-monthly-item-new'>{monthData.new}</span></SummaryEntry>
                  <SummaryEntry>Ongoing: <span className='fd-monthly-item-ongoing'>{monthData.ongoing}</span></SummaryEntry>
                  <SummaryEntry>Shutdown: <span className='fd-monthly-item-shutdown'>{monthData.shutdown}</span></SummaryEntry>
                  <SummaryEntry>Employees: <span style={{color:"#7B1FA2"}}>{monthData.monthCrewSize}</span></SummaryEntry>
                </SummaryBox>
              
            </SummaryBoxWrapper>
            <SummaryBoxWrapper>
              <div className="fd-info-entry-title">
                Daily Summary: {String((new Date()).getDate()).padStart(2, '0')}/{String((new Date()).getMonth() + 1).padStart(2, '0')}
              </div>

              <SummaryBox>
                  <SummaryEntry>New: <span className='fd-monthly-item-new'>{dailyData.new}</span></SummaryEntry>
                  <SummaryEntry>Ongoing: <span className='fd-monthly-item-ongoing'>{dailyData.ongoing}</span></SummaryEntry>
                  <SummaryEntry>Shutdown: <span className='fd-monthly-item-shutdown'>{dailyData.shutdown}</span></SummaryEntry>
                  <SummaryEntry>Employees: <span style={{color:"#7B1FA2"}}>{dailyData.todayCrewSize}</span></SummaryEntry>
                </SummaryBox>
            </SummaryBoxWrapper>
            <div className="fd-info-entry fd-info-entry-graph">
              {/* <ALLROADSydneyTrainsPie key={Date.now()} pieData = {pieData}/> */}
              <Iframe url={FORM_URL} height="700px" width="100%" frameBorder="0"/>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}
